import {createAction, props} from '@ngrx/store';
import {IMessage} from './_interfaces/IMessage';
import {MessageSeverityEnum} from './_interfaces/messageSeverity.enum';

// tslint:disable:max-line-length
export const sentMessage = createAction('[Messaging ✉️] message sent 👍', props<{message: IMessage}>());
export const sendDefault = createAction('[Messaging ✉️] send default message', props<{message: string, title?: string, severity?: MessageSeverityEnum}>());
export const sendWarning = createAction('[Messaging ✉️] send warning message', props<{message: string, title?: string, severity?: MessageSeverityEnum}>());
export const sendError = createAction('[Messaging ✉️] send error message', props<{message: string, title?: string, severity?: MessageSeverityEnum}>());
export const sendSuccess = createAction('[Messaging ✉️] send success message', props<{message: string, title?: string, severity?: MessageSeverityEnum}>());
export const markAsSeen = createAction('[Messaging ✉️] mark seen', props<{messageId: string}>());
